import { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";

export function LoadingScreen() {
  const [done, setDone] = useState(false);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const seen = sessionStorage.getItem("rentos-loaded");
    if (seen) { setDone(true); return; }
    const t = setTimeout(() => {
      sessionStorage.setItem("rentos-loaded", "1");
      setDone(true);
    }, 1600);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          className="fixed inset-0 z-[1000] grid place-items-center bg-background"
        >
          <div className="relative" role="status" aria-label="Loading RentOS">
            <motion.div
              initial={reducedMotion ? false : { opacity: 0, scale: 0.9 }}
              animate={reducedMotion ? { opacity: 1 } : { opacity: [0.65, 1, 0.65], scale: [0.96, 1, 0.96] }}
              transition={{ duration: 1.8, ease: "easeInOut", repeat: reducedMotion ? 0 : Infinity }}
              className="relative grid h-32 w-32 place-items-center"
            >
              <span aria-hidden="true" className="rentos-brand-ring absolute inset-0 rounded-full border border-primary/40" />
              <img src="/logo-icon.svg" alt="" width={80} height={80} className="rentos-splash-mark h-20 w-20" />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
